// extracted by mini-css-extract-plugin
export default {"EmbedCount":"EmbedCount_EmbedCount__dlQAm","count":"EmbedCount_count__WOxUn"};